import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';

import { InventoryService } from '../../../inventory/data-access/inventory.service';

@Component({
    selector: 'app-inventory-input',
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
    templateUrl: './inventory-input.component.html',
    styleUrl: './inventory-input.component.scss'
})
export class FormlyinventoryInputComponent extends FieldType<FieldTypeConfig<FormlyFieldSelectProps>> {
  public inventorys$ = this.inventoryService.dataQuery;

  constructor (private inventoryService: InventoryService) {
    super();
  }
}
